import React from 'react';
import styles from './header-widget.scss';

type Props = {
  searchInput?: React.ReactNode;
};

const HeaderWidget: React.FC<Props> = ({ searchInput }) => (
  <div className={styles.container}>
    <div className={styles.searchInput} data-hook="search-input">
      {searchInput}
    </div>
  </div>
);

export default HeaderWidget;
